import React from 'react';
import { Target, Eye, Heart, Award, Users, Globe } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: <Award className="w-8 h-8 text-primary-600" />,
      title: "Innovation",
      description: "Continuously exploring new technologies and methodologies."
    },
    {
      icon: <Heart className="w-8 h-8 text-primary-600" />,
      title: "Integrity",
      description: "Commitment to ethical practices and transparency."
    },
    {
      icon: <Users className="w-8 h-8 text-primary-600" />,
      title: "Customer-Centric",
      description: "Focused on delivering exceptional value and service to our clients."
    },
    {
      icon: <Target className="w-8 h-8 text-primary-600" />,
      title: "Excellence",
      description: "Striving for the highest quality in every aspect of our work."
    },
    {
      icon: <Heart className="w-8 h-8 text-primary-600" />,
      title: "Collaboration",
      description: "Working together with clients and partners to achieve shared goals."
    },
    {
      icon: <Globe className="w-8 h-8 text-primary-600" />,
      title: "Global Mindset",
      description: "We think beyond your current location by aiming to scale your business across the globe."
    }
  ];

  return (
    <section id="about" className="section-padding bg-secondary-50">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
            About Scale My Cloud
          </h2>
          <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
            Scale My Cloud is a cutting-edge software development, technology-savvy and 
            cloud operations enterprise startup based in the UK.
          </p>
        </div>

        {/* Mission and Vision */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="flex items-center mb-6">
              <div className="p-3 bg-primary-100 rounded-lg mr-4">
                <Eye className="w-8 h-8 text-primary-600" />
              </div>
              <h3 className="text-2xl font-bold text-secondary-900">Our Vision</h3>
            </div>
            <p className="text-secondary-700 leading-relaxed">
              To be a leading provider of cloud and software development services in a 
              digital world, renowned for innovation, efficiency, and reliability.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="flex items-center mb-6">
              <div className="p-3 bg-primary-100 rounded-lg mr-4">
                <Target className="w-8 h-8 text-primary-600" />
              </div>
              <h3 className="text-2xl font-bold text-secondary-900">Our Mission</h3>
            </div>
            <p className="text-secondary-700 leading-relaxed">
              To enable businesses to scale seamlessly with state-of-the-art technology 
              solutions tailored for optimum performance, security, and cost-effectiveness.
            </p>
          </div>
        </div>

        {/* Core Values */}
        <div className="text-center mb-12">
          <h3 className="text-2xl md:text-3xl font-bold text-secondary-900 mb-4">
            Our Core Values
          </h3>
          <p className="text-secondary-600 max-w-2xl mx-auto">
            These values guide everything we do and shape our approach to client relationships 
            and project delivery.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
            >
              <div className="mb-4">{value.icon}</div>
              <h4 className="text-xl font-semibold text-secondary-900 mb-3">
                {value.title}
              </h4>
              <p className="text-secondary-600">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        {/* Future Outlook */}
        <div className="mt-16 bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">Future Outlook</h3>
          <p className="text-primary-100 leading-relaxed max-w-4xl mx-auto">
            At Scale My Cloud, we are constantly evolving to stay ahead in the dynamic world 
            of technology. Our future initiatives include expanding our services in Artificial 
            Intelligence, machine learning, Technology Strategy, enhancing our cloud security 
            solutions, and exploring sustainable, green computing practices to minimize 
            environmental impact.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
